var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.115,
    height: 22.259,
    viewBox: "0 0 14.115 22.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(0 -1.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M231.061,281.641a6.955,6.955,0,0,0,4.243-6.4.691.691,0,1,0-1.381,0,5.575,5.575,0,0,1-5.569,5.569h-.215a5.512,5.512,0,0,1-2.167-.441,5.574,5.574,0,0,1-3.4-5.128.69.69,0,1,0-1.381,0,6.957,6.957,0,0,0,6.367,6.925v3.35h-3.7a.69.69,0,1,0,0,1.381h8.792a.69.69,0,1,0,0-1.381h-3.706v-3.35a6.879,6.879,0,0,0,2.124-.526Z",
    transform: "translate(-221.188 -262.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M266.492,72.531a3.6,3.6,0,0,0,1.143.772,3.555,3.555,0,0,0,1.4.284h.171a3.555,3.555,0,0,0,1.4-.284,3.627,3.627,0,0,0,1.915-1.915,3.555,3.555,0,0,0,.284-1.4V63.7a3.554,3.554,0,0,0-.284-1.4,3.627,3.627,0,0,0-1.915-1.915,3.556,3.556,0,0,0-1.4-.284h-.171a3.555,3.555,0,0,0-1.4.284A3.627,3.627,0,0,0,265.72,62.3a3.556,3.556,0,0,0-.284,1.4V69.99a3.555,3.555,0,0,0,.284,1.4A3.6,3.6,0,0,0,266.492,72.531Z",
    transform: "translate(-262.061 -58.361)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.1c8387e8966e9e131fdbb0d6d2a82442.svg";
export { ForwardRef as ReactComponent };